import { React, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useEffect } from "react";
const TempalteModal = ({ isVisible, onSave, onCancel, validations }) => {
    const [visitorName, setVisitorName] = useState("");

    useEffect(() => {
        if (!isVisible) {
            setVisitorName("");
        }
    }, [isVisible]);

    if (!isVisible) return null;

    const modalStyle = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
        },
        modal: {
            backgroundColor: '#fff',
            padding: '24px',
            borderRadius: '12px',
            width: '468px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            maxWidth: '90%', border: 'none',
        },
    };

    return (
        <div style={modalStyle.overlay}>
            <div style={modalStyle.modal}>


                <div style={{ marginTop: '0px', textAlign: 'center' }}>
                    <Col className="d-flex flex-column align-items-start">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ fontSize: "15px", fontWeight: "600", color: '#212129', fontFamily: "Epilogue" }}>
                                Save as tempalte
                            </div>
                        </div>
                        <div className="field-title" style={{ marginTop: '16px', }}>Template Name<span style={{ color: '#FF4444' }}>*</span></div>
                        <div style={{ width: "100%" }}>
                            <div style={{ marginBottom: "16px", marginTop: "16px", width: "100%" }}>
                                <input
                                    type="text"
                                    width={"100%"}
                                    placeholder="Enter here"
                                    className="form-control"
                                    value={visitorName}
                                    onChange={(event) => {
                                        setVisitorName(event.target.value);
                                    }}
                                    style={{ width: "100%" }}
                                />
                            </div>

                        </div>
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.name}</span>
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.fields}</span>
                        <div
                            style={{
                                width: "100%",
                                display: "flex", gap: "16px", alignItems: "end",
                                justifyContent: "flex-end"
                            }}
                        >
                            <button onClick={() => onCancel()}
                                style={{
                                    borderRadius: "100px",
                                    border: "1px solid #E5E5E5",
                                    padding: "10px 28px",
                                    backgroundColor: "#FFFFFF",
                                    fontWeight: "700",
                                    fontSize: "14px",
                                    color: "#172B4D",
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={() => onSave(visitorName)}
                                style={{
                                    borderRadius: "100px",
                                    border: "1px solid #E5E5E5",
                                    padding: "10px 28px",
                                    backgroundColor: "#2C8C53",
                                    fontWeight: "700",
                                    fontSize: "14px",
                                    color: "#FFFFFF",
                                }}
                            >
                                Save
                            </button>
                        </div>
                    </Col>
                </div>
            </div >
        </div >
    );
};

export default TempalteModal;
